/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetDictionaryDto,
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
    GetOrganizationDto,
    GetOrganizationDtoFromJSON,
    GetOrganizationDtoFromJSONTyped,
    GetOrganizationDtoToJSON,
    GetOrganizationalUnitDto,
    GetOrganizationalUnitDtoFromJSON,
    GetOrganizationalUnitDtoFromJSONTyped,
    GetOrganizationalUnitDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetSampleCollectDto
 */
export interface GetSampleCollectDto {
    /**
     * 
     * @type {string}
     * @memberof GetSampleCollectDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSampleCollectDto
     */
    fileNumber: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetSampleCollectDto
     */
    collectBasis: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetSampleCollectDto
     */
    collectPlace: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSampleCollectDto
     */
    approved: boolean;
    /**
     * 
     * @type {GetOrganizationDto}
     * @memberof GetSampleCollectDto
     */
    organization: GetOrganizationDto;
    /**
     * 
     * @type {string}
     * @memberof GetSampleCollectDto
     */
    cautionText: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSampleCollectDto
     */
    cautionIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSampleCollectDto
     */
    cautionValues: Array<string>;
    /**
     * 
     * @type {GetOrganizationalUnitDto}
     * @memberof GetSampleCollectDto
     */
    examOrganizationalUnit: GetOrganizationalUnitDto;
    /**
     * 
     * @type {Date}
     * @memberof GetSampleCollectDto
     */
    signatureDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSampleCollectDto
     */
    placeOfSignature: string;
    /**
     * 
     * @type {string}
     * @memberof GetSampleCollectDto
     */
    refusalReason: string;
    /**
     * 
     * @type {string}
     * @memberof GetSampleCollectDto
     */
    attachments: string;
    /**
     * 
     * @type {string}
     * @memberof GetSampleCollectDto
     */
    protocols: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSampleCollectDto
     */
    actionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSampleCollectDto
     */
    witness: string;
}

export function GetSampleCollectDtoFromJSON(json: any): GetSampleCollectDto {
    return GetSampleCollectDtoFromJSONTyped(json, false);
}

export function GetSampleCollectDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSampleCollectDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileNumber': json['fileNumber'],
        'collectBasis': GetDictionaryDtoFromJSON(json['collectBasis']),
        'collectPlace': json['collectPlace'],
        'approved': json['approved'],
        'organization': GetOrganizationDtoFromJSON(json['organization']),
        'cautionText': json['cautionText'],
        'cautionIds': json['cautionIds'],
        'cautionValues': json['cautionValues'],
        'examOrganizationalUnit': GetOrganizationalUnitDtoFromJSON(json['examOrganizationalUnit']),
        'signatureDate': !exists(json, 'signatureDate') ? undefined : (new Date(json['signatureDate'])),
        'placeOfSignature': json['placeOfSignature'],
        'refusalReason': json['refusalReason'],
        'attachments': json['attachments'],
        'protocols': json['protocols'],
        'actionDate': !exists(json, 'actionDate') ? undefined : (new Date(json['actionDate'])),
        'witness': json['witness'],
    };
}

export function GetSampleCollectDtoToJSON(value?: GetSampleCollectDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fileNumber': value.fileNumber,
        'collectBasis': GetDictionaryDtoToJSON(value.collectBasis),
        'collectPlace': value.collectPlace,
        'approved': value.approved,
        'organization': GetOrganizationDtoToJSON(value.organization),
        'cautionText': value.cautionText,
        'cautionIds': value.cautionIds,
        'cautionValues': value.cautionValues,
        'examOrganizationalUnit': GetOrganizationalUnitDtoToJSON(value.examOrganizationalUnit),
        'signatureDate': value.signatureDate === undefined ? undefined : (value.signatureDate.toISOString()),
        'placeOfSignature': value.placeOfSignature,
        'refusalReason': value.refusalReason,
        'attachments': value.attachments,
        'protocols': value.protocols,
        'actionDate': value.actionDate === undefined ? undefined : (value.actionDate.toISOString()),
        'witness': value.witness,
    };
}


